import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from "react-redux";
import { NavBar } from "..";
import CheckoutResultsBanner from "./CheckoutResultsBanner";
import { useEffect } from "react";
import { fetchProfileDataThunk } from "Root/profile/redux/thunkCreators/myProfile/profileThunk";
import CheckoutRecommendations from "./CheckoutRecommendations";
import { useHistory } from "react-router";
import CheckoutResultReviews from "./CheckoutResultsReviews";
import posthog from "posthog-js";
import CheckoutHapinessGuarantee from "./CheckoutHapinessGuarantee";
import { useShowInterstitial } from "../IngredientsPage/hooks";
import { IngredientsModal } from "CheckoutComponents/IngredientsPage/components";
import { capitalize } from "Root/profile/utils";
const CheckoutResultsNew = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const userCart = useSelector((state) => state.checkoutUserCart.userCart);
    const bannerData = useSelector((state) => state.checkoutComponent.bannerData);
    const userName = useSelector((state) => state.user.name);
    const getFirstName = () => {
        const name = userName.split(" ");
        return name[0];
    };
    const { showScreen, showPage } = useShowInterstitial();
    const proceedToCheckout = () => {
        history.push("/checkout/cart");
    };
    useEffect(() => {
        dispatch(fetchProfileDataThunk(false));
        posthog?.capture("$pageview");
    }, []);
    return (_jsxs(_Fragment, { children: [showScreen && getFirstName && _jsx(IngredientsModal, { name: capitalize(getFirstName()) }), _jsx(NavBar, { isOneButton: true, continue: proceedToCheckout, active: 1, cart: userCart, bannerData: bannerData }), _jsx(CheckoutResultsBanner, {}), _jsx(CheckoutRecommendations, {}), _jsx(CheckoutResultReviews, {}), _jsx(CheckoutHapinessGuarantee, {})] }));
};
export default CheckoutResultsNew;
